import React, { useEffect, useState } from "react";
import { req, tr } from "./api";

export default function Dashboard({ go }) {
  const [d, setD] = useState(null);
  useEffect(() => { req("/admin/dashboard").then(setD).catch(() => setD({})); }, []);
  if (!d) return <p className="muted">Loading…</p>;
  return (
    <div data-testid="admin-dashboard">
      <div className="stat-grid">
        <button className="stat-card" style={{ textAlign: "left", cursor: "pointer" }} onClick={() => go("enquiries")} data-testid="dash-new-enquiries">
          <span className="v num">{d.newEnquiries ?? 0}</span><span className="l">New enquiries</span>
        </button>
        <button className="stat-card" style={{ textAlign: "left", cursor: "pointer" }} onClick={() => go("meetings")} data-testid="dash-req-bookings">
          <span className="v num">{d.requestedBookings ?? 0}</span><span className="l">Meeting requests to confirm</span>
        </button>
        <div className="stat-card"><span className="v num">{(d.upcomingEvents || []).length}</span><span className="l">Upcoming events</span></div>
      </div>
      <div className="g2">
        <div className="stack" style={{ gap: 12 }}>
          <span className="eyebrow">Next events</span>
          {(d.upcomingEvents || []).length ? (
            <div className="tbl-wrap"><table className="tbl"><thead><tr><th>Event</th><th>Date</th><th>Registered</th></tr></thead>
              <tbody>{(d.upcomingEvents || []).map((e) => (
                <tr key={e.id}><td>{tr(e.title)}</td><td className="num">{new Date(e.startsAt).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}</td><td className="num">{e.registrations}{e.capacity ? " / " + e.capacity : ""}</td></tr>))}</tbody></table></div>
          ) : <div className="empty">No upcoming events.</div>}
        </div>
        <div className="stack" style={{ gap: 12 }}>
          <span className="eyebrow">Latest enquiries</span>
          {(d.recentEnquiries || []).length ? (
            <div className="tbl-wrap"><table className="tbl"><thead><tr><th>From</th><th>Received</th><th>Status</th></tr></thead>
              <tbody>{(d.recentEnquiries || []).map((e) => (
                <tr key={e.id}><td>{e.name}</td><td className="num">{new Date(e.createdAt).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}</td><td><span className={`pill${e.status === "new" ? " on" : ""}`}>{e.status}</span></td></tr>))}</tbody></table></div>
          ) : <div className="empty">No enquiries yet.</div>}
          {(d.recentChanges || []).length ? (
            <>
              <span className="eyebrow" style={{ marginTop: 12 }}>Recent changes</span>
              <ul className="muted small" style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {d.recentChanges.map((a) => <li key={a.id}>{a.user} · {a.action} · {a.collection}/{a.item} · <span className="num">{new Date(a.at).toLocaleString("en-GB")}</span></li>)}
              </ul>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
